<template lang="pug">
  .hamburger
    .hamburger_line.hamburger_line-upper(v-bind:class="{'hamburger_line-disabled': disabled, 'hamburger_line-none': none, 'hamburger_line-filled': filled}")
    .hamburger_line.hamburger_line-middle(v-bind:class="{'hamburger_line-disabled': disabled, 'hamburger_line-none': none, 'hamburger_line-filled': filled}")
    .hamburger_line.hamburger_line-lower(v-bind:class="{'hamburger_line-disabled': disabled, 'hamburger_line-none': none, 'hamburger_line-filled': filled}")

</template>
<script>

  export default {
    props: ['disabled', 'none', 'filled']
  }
</script>
<style lang="sass">
  .hamburger
    width: 20px
    height: 20px
    box-sizing: border-box
    padding: 3px 0
    &_line
      background-color: #fff
      height: 2px
      width: 20px
      transition: background-color .1s linear
      &-upper
        margin-bottom: 4px
      &-middle
        margin-bottom: 4px
      &-lower
      &-filled
        background-color: #000
      &-none
        background-color: #000
      &-disabled
        background-color: #666
</style>